<template>
    <div id="homeBox">
        <div class="flexcenter" id="flexcenter">
            <!--  新增按钮      -->
            <el-button type="text" style="height: 2.5rem"  icon="el-icon-plus"  @click="addLine">新增产线</el-button>
            <!-- 搜索区域-->
            <div style="margin-right: 20px">
                <!-- 搜索框 -->
                <el-input
                        size="mini"
                        style="width: 200px  "
                        placeholder="请输入搜索内容"
                        v-model="keyWord"
                        clearable>
                </el-input>
                <!-- 搜索按钮 -->
                <el-button  class="mrl15 " icon="el-icon-search" circle  @click="SearchLine" size="mini"></el-button>
            </div>

        </div>
        <!--  父表格  -->
        <el-table
                id="eltable"
                ref="ftable"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                style="width: 100%"
                row-key="no"
                stripe
                border
                :header-cell-style="{background:'#eef1f6',color:'black',}"
                :header-row-style="{height:'50px'}"
                :highlight-current-row="true"
                @expand-change="dddd"
        >
            <el-table-column type="expand"  ref="tree">

                <!--   子表   -->
                <template slot-scope="scope" width="1">
                    <el-table
                            ref="table"
                            size="mini"
                            border
                            :data="scope.row.child"
                            :header-cell-style="{background:'#F0FFFF',color:'#000',}"
                    >
                        <el-table-column
                                prop="procedureName"
                                label="流程名"
                                align="center"
                                width="300"
                                show-overflow-tooltip>

                        </el-table-column>
                        <el-table-column
                                label="类型"
                                width="90"
                                show-overflow-tooltip
                        >
                            <template slot-scope="scope" >
                                <div >
                                    <span v-if="scope.row.type==0">无</span>
                                    <span v-if="scope.row.type==1">温度</span>
                                    <span v-if="scope.row.type==2">压力</span>
                                    <span v-if="scope.row.type==3">液位</span>
                                    <span v-if="scope.row.type==4">瞬时流量</span>
                                    <span v-if="scope.row.type==5">累计流量</span>
                                    <span v-if="scope.row.type==6">耗电量</span>
                                    <span v-if="scope.row.type==7">用汽量</span>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                                prop="order"
                                label="次序"
                                width="50"
                                show-overflow-tooltip
                        >
                        </el-table-column>

                        <el-table-column

                                label="状态"
                                width="80"
                                show-overflow-tooltip
                        >
                            <template slot-scope="scope" >
                                <div >
                                    <span v-if="scope.row.state==1">运行中</span>
                                    <span v-if="scope.row.state==2">调整中</span>
                                    <span v-if="scope.row.state==3">停机</span>
                                </div>

                            </template>
                        </el-table-column>

                        <el-table-column
                                width="70"
                                prop="createPreson1"
                                label="录入人"
                                show-overflow-tooltip>
                        </el-table-column>

                        <el-table-column
                                prop="createTime1"
                                width="90"
                                label="录入时间"
                                show-overflow-tooltip>
                        </el-table-column>

                        <el-table-column
                                width="130"
                                label="操作">
                            <template slot-scope="scope" >
                                <div >
                                    <el-button  type="text" size="mini" @click="editson(scope.row)">编辑</el-button>
                                    <el-button style="color:red;" type="text" size="mini" @click="delson(scope.row,scope.$index)">删除</el-button>
                                </div>
                            </template>
                        </el-table-column>

                    </el-table>
                </template>
                <!--   子表   -->

            </el-table-column>
            <el-table-column
                    prop="no"
                    :label="$t('form_serial_number')"
                    width="50"
                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    prop="name"
                    label="产线名"
                    width="90"
                    show-overflow-tooltip
            >
            </el-table-column>

            <el-table-column
                    prop="workSection"
                    label="工段"
                    width="70"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="product"
                    label="产品"
                    width="90"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    label="状态"
                    width="80"
                    show-overflow-tooltip
            >
                <template slot-scope="scope" >
                    <div >
                        <span v-if="scope.row.state==1">运行中</span>
                        <span v-if="scope.row.state==2">调整中</span>
                        <span v-if="scope.row.state==3">停机</span>
                    </div>

                </template>
            </el-table-column>

            <el-table-column
                    width="70"
                    prop="createPreson"
                    label="录入人"
                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    prop="createTime"
                    width="90"
                    label="录入时间"
                    show-overflow-tooltip>

            </el-table-column>
            <el-table-column
                    width="170"
                    label="操作">
                <template slot-scope="scope" >
                    <div >
                        <el-button  type="text" size="mini" @click="editLine(scope.row)">编辑</el-button>
                        <el-button  style="color:red;"  type="text" size="mini" @click="del(scope.$index)">{{$t('button_nullify')}}</el-button>
                        <el-button    type="text" size="mini" @click="addson(scope.row,scope.$index)">新增流程</el-button>
                        <!--                        <el-button v-if="scope.row.dcsNum!==0"   type="text" size="mini" @click="seedetail(scope.row)">{{scope.row.see==1?'收起':'查看'}}</el-button>-->
                    </div>

                </template>
            </el-table-column>
        </el-table>
        <!-- 父表格 -->

        <!-- 分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother  fl">
                    <!--
                    small：是否使用小型分页样式
                    page-size:每页显示的条目数
                    page-sizes：每页显示个数选择器的选项设置
                    total：总条目数
                    current-page：当前页数，支持 .sync 修饰符
                    layout：组件布局，子组件名用逗号分隔

                    size-change：pageSize改变时会触发  回调参数为每页条数
                    current-change：currentPage 改变时会触发  回调参数为当前页
                    -->
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[1, 2]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <!--
                    small：是否使用小型分页器
                    page-size:每页显示的条目数
                    page-sizes：每页显示个数选择器的选项设置
                    total：条目总数
                    current-page：当前页数，支持 .sync 修饰符
                    layout：组件布局，子组件名用逗号分隔

                    size-change：pageSize改变时会触发  回调参数为每页条数
                    current-change：currentPage 改变时会触发  回调参数为当前页
                    -->

                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :pager-count="5"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">

                    </el-pagination>
                </div>

            </div>
        </div>
        <!-- 分页器-->
        <!--  新增产线弹窗(父)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                top="350px"
                width="31.429rem"
                height="300"
                :title="title"
                :visible.sync="productLines"
                v-if="productLines"


        >
<!--            <adddcs :listid="listid" @clist="clist" @list="list" @dcslist="dcslist" :editData="editData" @close="close"></adddcs>-->
            <addline @lineList="getLineList" @close="close" :lineList = "lineList"></addline>
        </el-dialog>

        <!--  弹窗  -->
        <!--  新增流程弹窗(子)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                top="100px"
                width="500px"
                height="300"
                :title="title"
                :visible.sync="flowPath"
                v-if="flowPath"
        >
<!--            <addson  @list="list" :editData="editData" @close="close"></addson>-->
            <addson @procedureList="getPathList" @close="close" :procedureList="procedureList"></addson>
        </el-dialog>

        <!--  弹窗  -->
        <!--  删除产线弹窗(父)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delLine"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delLine"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{deldetail}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delLine = false">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="submitdel">确 定</el-button>
  </span>
        </el-dialog>

        <!--  弹窗  -->
        <!--  删除流程弹窗(子)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delsonDialog"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delsonDialog"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{deldetail}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delsonDialog = false">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="submitsondel">确 定</el-button>
  </span>
        </el-dialog>
        <!--  弹窗  -->
    </div>
</template>

<script>
    import {baseerp} from "@/utils/baseUrl";
    // import * as API from "./api";
    import {mapActions} from "vuex";
    import addline from "./component/AddLine";

    //import adddcs from "./component/AddDcs";
     import addson from "./component/AddSon";

    export default{
        name:'ProductManage',
        components:{
            // adddcs,
            //  addson,
            // addline
        },

        data(){
            return{
                lineList:{},
                procedureList:{},
                lineData:{},
                lineIndex:'',
                sonIndex:"",
                fno:'',
                addData:{},

                delLine:false,
                delsonDialog:false,
                flowPath:false,
                see:false,
                maps:new Map(),
                childrenlist:[],
                loading:'',
                sbtype:[{
                    id:1,
                    v:'水表'
                },{
                    id:2,
                    v:'电表'
                },{
                    id:3,
                    v:'气表'
                },{
                    id:4,
                    v:'气表'
                },{
                    id:5,
                    v:'压力表'
                },{
                    id:6,
                    v:'温度表'
                },{
                    id:7,
                    v:'液位计'
                },{
                    id:8,
                    v:'PH'
                },{
                    id:9,
                    v:'直罐'
                },{
                    id:10,
                    v:'卧罐'
                },
                    {
                        id:11,
                        v:'球罐'
                    },{
                        id:12,
                        v:'流量计'
                    }],
                editData:{},
                productLines:false,//编辑弹窗
                keyWord:'',//搜索关键词
                currentPage:1,
                pageSize:1,
                deldetail:'',
                total:0,
                listid:0,
                baseerp:'',
                searchData:[],
                tableData: [
                    {no:1,name:"一号线",workSection:"一工段",product:"甲醇",state:1,createPreson:'张三',createTime:"2023-4-25",child:[
                        {procedureName:1,type:2,order:1,state:1,createPreson1:"张三",createTime1:"2023-4-25",fno:1},
                        {procedureName:1,type:2,order:1,state:1,createPreson1:"李四",createTime1:"2023-4-25",fno:1}
                            ]},
                    {no:2,name:"二号线",workSection:"一工段",product:"液氮",state:2,createPreson:'张三',createTime:"2023-4-25",child:[
                        {procedureName:1,type:2,order:1,state:1,createPreson1:"张三",createTime1:"2023-4-25",fno:2}
                        ]},
                ],

                tableHeight:0,//列表高度
                consumername:[],//消费名字数据
                title:'',
                delDialogVisible:false//删除弹框
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.total = this.tableData.length
            this.$nextTick(()=>{
                this.onResize();

            })
            // this.$refs.deliverlight.toggleRowExpansion(item,false)
            //公共样式
            this.baseerp=baseerp
            // this.dcslist()
            // this.$nextTick(function () {
            //     this.heightAuto();
            // window.addEventListener('resize',this.onResize);

            // });

        },

        beforeDestroy() {
            // window.removeEventListener('resize',this.heightAuto)
        },
        methods:{
            //新增产线
            getLineList(value){
                //console.log(this.title)
                if(this.title==='新增产线') {
                    this.tableData.push(value)
                }
                this.productLines=false
            },
            //新增流程
            getPathList(value){
                //console.log(value)//得到子数据
            if(this.title==='新增流程') {
                this.tableData[this.sonIndex].child.push(value)
            }
                this.flowPath=false
            },

            clist(){
                this.tableData.forEach(item=>{
                    this.$refs.ftable.toggleRowExpansion(item,false)

                })
                // this.$refs.deliverlight.toggleRowExpansion(item,false)

            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            ...mapActions(["getCurrentMenuId"]),
            //高度

            heightAuto(){
                // this.$nextTick(()=>{
                //     document.getElementById('body').getBoundingClientRect().top
                // })
                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36;
                // console.log(this.tableHeight)
                // console.log(document.getElementById('body').getBoundingClientRect().top)
                // console.log(window.innerHeight)
                // console.log()
            },

            //关闭弹框
            close(){
                this.flowPath=false
                this.productLines=false
            },
            //页面搜索
            SearchLine(){
                //this.dcslist()
                //console.log(this.tableData)

               // console.log(iteam.name.shift(this.Searchdata))
                    this.searchData =  this.tableData.filter((p)=>{
                        //console.log(p)
                        if(p===null){
                            return this.tableData !== -1
                        }else {
                            if(p.name.includes(this.keyWord)){
                                return p.name.indexOf(this.keyWord) !== -1
                            }else {
                                if(p.workSection.includes(this.keyWord)){
                                    return p.workSection.indexOf(this.keyWord) !== -1
                                }else {
                                    if(p.product.includes(this.keyWord)){
                                        return p.product.indexOf(this.keyWord) !== -1
                                    }
                                }
                            }
                        }

                    })
                // console.log(this.searchData)
                //this.tableData.forEach(item=>{
                    //console.log(this.tableData.shift())
                    //console.log(this.$refs.ftable)
                    //console.log(item.name.includes(this.Searchdata))
                    //if(iteam.name.includes(this.Searchdata)){
                        //console.log(iteam.name.shift(this.Searchdata))
                    //}else {
                        ///this.tableData.shift()
                    //}
                    //this.$refs.ftable.toggleRowExpansion(item,false)
                //})
                // this.$refs.tree.root.expanded = false;
                this.currentPage=1
            },
            //分页
            //监听pagesize改变的事件
            handleSizeChange(newsize) {
                //console.log(`每页 ${newsize} 条`);
                //最新的条数（newsize）赋值给 动态的 pageSize
                this.pageSize = newsize;    //动态改变

                //获取到最新一页显示的数据  重新发送请求
                //this.clist()
                //this.dcslist()
            },
            // 监听 页码值 改变的数据
            //监听页码值改变的数据
            handleCurrentChange(newPage) {
                // console.log(`当前页: ${newPage}`);
                //把最新的页码（newPage）赋值给 动态的 currentPage
                this.currentPage = newPage;    //动态改变
                //获取到最新页码值  重新发送请求
                //this.clist()
                //this.dcslist()
            },
            //新增产线
            addLine(){
                this.title='新增产线'
                this.lineList={}
                this.productLines=true
                // this.editData={
                //     nfc:"",
                //     no:"",
                //     type:'',
                //     name:"",
                //     dcsNo:"",
                //     position:"",
                //     calculationFormula:"",
                //     inspectionPeriod:'',
                //     inspectionTime:"",
                //     buyTime:"",
                //     regisTime:"",
                //     guaranteeTime:"",
                //     moneyBuy:"",
                //     personLiableId:'',
                //     orderNo:1,
                //     description:"",
                //     // isNfc:1,
                //     isDcs:1,
                //
                //
                //     id:0,
                //     lruid:parseFloat(sessionStorage.getItem("userid")) ,
                //     vc_lruname:sessionStorage.getItem('lruname'),
                //     state:1
                //
                // }

            },
            //新增流程(子)
            addson(val,index){
                this.title='新增流程'
                this.sonIndex= index
                this.procedureList={}
                this.flowPath=true

                // this.listid=e.
                // this.editData={
                //     id:0,
                //     orderNo:1,
                //     dcsWidth
                //         :
                //         "",
                //
                //     inputTitle
                //         :
                //         "",
                //     inputType
                //         :
                //         "",
                //     inputUnit
                //         :
                //         "",
                //     inputWidth
                //         :
                //         "",
                //     lowerBound
                //         :
                //         "",
                //     name
                //         :
                //         "",
                //     no
                //         :
                //         "",
                //     pid
                //         :
                //     e.id,
                //     upperBound
                //         :
                //         "",
                //     lruid:parseFloat(sessionStorage.getItem("userid")) ,
                //     vc_lruname:sessionStorage.getItem('lruname'),

                //}

            },
            //aaaa
            // async list(val) {
            //     let result = await this.getCurrentMenuId({path: this.$route.path});
            //     if (result.i_id !== "") {
            //         this.mid = result.i_id
            //         sessionStorage.setItem('mids', result.i_id)
            //     } else {
            //         this.mid = sessionStorage.getItem('mids')
            //     }
            //     let params = {
            //         pid:this.listid
            //         // isNext:this.editData.isNext
            //     }
            //     // console.log(params)
            //     // return
            //     let res = await API.list(params);
            //     if (res.code == 1) {
            //
            //         this.tableData.forEach(item=>{
            //             if(item.id==this.listid){
            //                 this.$set(item,'erbei',res.data)
            //
            //             }
            //         })
            //         // console.log(this.listid)
            //         // console.log(this.tableData)
            //         // this.childrenlist=res.data
            //
            //     } else if (res.code == -2) {
            //         // this.loading.loading=false
            //
            //         this.$router.push('/login');
            //         this.$message.error(res.message);
            //     } else {
            //         // this.loading.loading=false
            //
            //         this.$message.error(res.message);
            //     }
            // },
            //编辑生产线(父)
            editLine(val){
                // console.log(val)
                this.title='编辑产线'
                // console.log(val)
                this.lineList = val
                //this.editData.id=val.id
                //this.editData=Object.assign({},val);
                this.productLines=true
                // this.getServiceConfigDetail()

                // console.log(this.editData)
            },
            editson(value){
                //console.log(value)
                this.title='编辑流程'
                this.procedureList = value
                //console.log(this.procedureList)
                //this.listid=e.pid
                // console.log(e)
                // this.editData.pid=e.id
                //this.editData=Object.assign({},e);
                // this.dcsdetail()
                this.flowPath=true
            },


            //作废流程(子)
            delson(val,index){
                this.title='删除'
                //console.log("child数组的"+val.fno,index)
                this.sonIndex=index
                // this.templateUsed()
                this.fno = val.fno
                this.deldetail='是否要删除'
                this.delsonDialog=true
            },
            //流程确认作废(子)
            submitsondel(){
                //this.dcsdelete()
                let index = this.tableData.map((item) => item.no).indexOf(this.fno);
                //console.log(index)
                //console.log(this.tableData[index].child[this.sonIndex])
                this.tableData[index].child.splice(this.sonIndex,1)
                // 1
                // this.tableData.forEach(e=>{
                //     console.log(e)
                //     e.child.splice(this.sonIndex,1)
                // })
                this.delsonDialog=false

            },
            //删除产线(父)
            del(index){
                this.title='删除'
                this.lineIndex=index
                //this.editData=val
                // this.templateUsed()
                this.deldetail='是否要删除'

                this.delLine=true

                // console.log(this.editData)
                // console.log(this.editData.id)
            },
            //产线确认作废(父)
            submitdel(){

                this.tableData.splice(this.lineIndex,1)
                //this.dcscancel()
                //this.clist()

                // console.log(this.editData)
                this.delLine=false
            },

            //业务配置列表查询
            // async linelist() {
            //     let result = await this.getCurrentMenuId({path: this.$route.path});
            //     if (result.i_id !== "") {
            //         this.mid = result.i_id
            //         //sessionStorage：将数据保存在浏览器中
            //         //sessionStorage.setItem()：创建sessionStorage，括号内为要保存的数据
            //         //result.i_id:需要保存的数据
            //         //mids：为这些数据创建自定义名称
            //         sessionStorage.setItem('mids', result.i_id)
            //     } else {
            //         this.mid = sessionStorage.getItem('mids')
            //     }
            //     let params = {
            //         search:this.Searchdata,
            //         currentPage: this.currentPage,
            //         pageSize: this.pageSize
            //     }
            //     let res = await API.linelist(params);
            //     //console.log(res)
            //     //let res = await API.dcslist(params);
            //     if (res.code == 1) {
            //         // console.log(this.listid)
            //         this.tableData=res.data.list
            //         this.total=res.data.total
            //         // this.$nextTick(()=>{
            //         this.tableData.forEach(item=>{
            //             item.createTime=item.createTime.substring(0,10)
            //
            //             // console.log(this.$refs.deliverlight.toggleRowExpansion(item,false))
            //
            //
            //
            //         })
            //
            //         // document.getElementsByClassName('.el-icon-arrow-right').
            //         // this.$forceUpdate()
            //         // })
            //         //
            //
            //         // console.log(this.tableData)
            //     } else if (res.code == -2) {
            //         this.$router.push('/login');
            //         this.$message.error(res.message);
            //     } else {
            //         this.$message.error(res.message);
            //     }
            // },
            load(tree,treeNode,resolve){
                // this.loading=i
                this.maps.set(tree.id, {tree, treeNode, resolve});

                // console.log(i,q)
                // setTimeout(()=>{
                //     resolve(
                //         this.childrenlist
                //     )
                // },1000)
            },

            dddd(e,i){
                const isExpend = i.some(r => r.id === e.id) // 判断当前行展开状态
                if (isExpend) {
                    this.listid=e.id
                    this.list()
                    // this.tableData.forEach(item=>{
                    // if(this.listid!==item.id){
                    // this.$refs.deliverlight.toggleRowExpansion(item,false)
                    // console.log(this.$refs.deliverlight.toggleRowExpansion(item,false))

                    // }
                    // })
                    // console.log(e,i)

                    // Do some things
                } else {
                    return
                }

            },
            //dcs作废验证
            //取消作废
            // async dcscancel() {
            //     let result = await this.getCurrentMenuId({path: this.$route.path});
            //     if (result.i_id !== "") {
            //         this.mid = result.i_id
            //         sessionStorage.setItem('mids', result.i_id)
            //     } else {
            //         this.mid = sessionStorage.getItem('mids')
            //     }
            //     let params = {
            //         id:this.editData.id,
            //         state:-1
            //     }
            //     let res = await API.dcscancel(params);
            //     if (res.code == 1) {
            //         this.dcslist()
            //         this.$message({
            //             message: '删除成功',
            //             type: 'success'
            //         });
            //         // this.deldetail='是否要删除'
            //         // console.log(res)
            //     } else if (res.code == -2) {
            //
            //         this.$router.push('/login');
            //         this.$message.error(res.message);
            //     } else {
            //         // console.log(res)
            //         // this.deldetail=res.message
            //
            //         this.$message.error(res.message);
            //     }
            // },
            // //确认作废
            // async dcsdelete() {
            //     let result = await this.getCurrentMenuId({path: this.$route.path});
            //     if (result.i_id !== "") {
            //         this.mid = result.i_id
            //         sessionStorage.setItem('mids', result.i_id)
            //     } else {
            //         this.mid = sessionStorage.getItem('mids')
            //     }
            //     let params = {
            //         id:this.editData.id,
            //
            //     }
            //     let res = await API.dcsdelete(params);
            //     if (res.code == 1) {
            //         this.list()
            //         this.$message({
            //             message: '删除成功',
            //             type: 'success'
            //         });
            //         // this.deldetail='是否要删除'
            //         // console.log(res)
            //     } else if (res.code == -2) {
            //
            //         this.$router.push('/login');
            //         this.$message.error(res.message);
            //     } else {
            //         // console.log(res)
            //         // this.deldetail=res.message
            //
            //         this.$message.error(res.message);
            //     }
            // },



        },

    }
</script>
<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/.el-table__expanded-cell{
        padding: 5px 0px;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    /deep/.el-table__header{
        width: 100% !important;
    }
    /deep/.el-table__body{
        width: 100% !important;

    }
    .left{
        width: 17.857rem;
    }
</style>